import React, { ReactNode, createContext, useContext, useEffect, useState } from "react";
import { ProductModel } from "../models/product";

type ShopContextType = {
    cartItems: ProductModel[];
    setCartItems: (cartItems: ProductModel[]) => void;
    deleteFromCart: (itemCode: number) => void;
    addItem: (itemCode: number, product: ProductModel) => void;
    removeItem: (itemCode: number) => void;
    manualAddRemoveItem: (itemCode: number, produce: ProductModel, newCount: number) => void;
    calculateTotal: () => number;
    getCartAmount: (itemCode: number) => number;
}

const ShopContext = createContext<ShopContextType | undefined>(undefined);

export const useShopContext = () => {
    const context = useContext(ShopContext);
    if (!context) {
        throw new Error('context error');
    }
    return context;
};

export const ShopContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    //const [cartItems, setCartItems] = useState<ProductModel[]>([]);

    const [cartItems, setCartItems] = useState<ProductModel[]>(() => {
        const storedCartItems = localStorage.getItem('cartItems');
        return storedCartItems ? JSON.parse(storedCartItems) : [];
    });

    useEffect(() => {
        const storedCartItems = localStorage.getItem('cartItems');
        if (storedCartItems) {
            setCartItems(JSON.parse(storedCartItems));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('cartItems', JSON.stringify(cartItems));
    }, [cartItems]);


// INCREASE ITEM AMOUNT

    const addItem = (itemCode: number, product: ProductModel) => {
        const index = cartItems.findIndex(item => item.ID === itemCode);

        if (index !== -1){
            if (cartItems[index].AMOUNT < cartItems[index].QUANTITY) {
                setCartItems(prev => prev.map(item => item.ID === itemCode ? { ...item, AMOUNT: item.AMOUNT + 1 } : item));
            }
        } else {
            setCartItems(prev => [...prev, {...product, AMOUNT: 1 }]);
        };
    };


// DELETE ITEM FROM CART

const deleteFromCart = (itemCode: number) => {
    setCartItems(prev => prev.filter(item => Number(item.ID) !== Number(itemCode)));
};


// DECREASE ITEM AMOUNT

    const removeItem = (itemCode: number) => {
        const index = cartItems.findIndex(item => item.ID === itemCode);
        
        if (index !== -1) {
            if (cartItems[index].AMOUNT >1) {
                setCartItems(prev => prev.map(item => item.ID === itemCode ? { ...item, AMOUNT: item.AMOUNT - 1 } : item));
            }
            else {
                setCartItems(prev => prev.filter(item => Number(item.ID) !== Number(itemCode)));
            }
        };
    };


// CHANGE ITEM AMOUNT FROM TEXTBOX

    const manualAddRemoveItem = (itemCode: number, product: ProductModel, newCount: number) => {
        const index = cartItems.findIndex(item => item.ID === itemCode);
        if (index !== -1) {
            if (newCount > 0 && newCount <= cartItems[index].QUANTITY) {
                setCartItems(prev => prev.map(item => item.ID === itemCode ? { ...item, AMOUNT: newCount } : item));
            }
            if (newCount === 0) {
                setCartItems(prev => prev.filter(item => Number(item.ID) !== Number(itemCode)));
            }
        } else {
            setCartItems(prev => [...prev, {...product, AMOUNT: newCount }]);
        };
    };


// CALCULATE CART TOTAL

    const calculateTotal = () => {
        if (cartItems.length > 0) {
                    let totalPrice=0;
                    for (const item in cartItems) {
                        if (cartItems[item].AMOUNT > 0) {
                            totalPrice += cartItems[item].PRICE * cartItems[item].AMOUNT;
                        }
                    }
                    return totalPrice;
        } else {
            return 0;
        }
    }


    // GET CART AMOUNT TO DISPLAY ON THE SHOP PAGE

    const getCartAmount = (itemCode: number) => {
        const index = cartItems.findIndex(item => item.ID === itemCode);
        if (index !== -1) {
            return cartItems[index].AMOUNT;
        } else {
           return 0;
        }
    };

    const contextValue = { cartItems, setCartItems, deleteFromCart, addItem, removeItem, manualAddRemoveItem, calculateTotal, getCartAmount };

    return (
        <ShopContext.Provider value={contextValue}>
            {children}
        </ShopContext.Provider>
    );
};